<template>
  <div>
    <Head title="Create Item" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/items">
        Items
      </Link>
      <span class="text-indigo-400 font-medium"> / </span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pb-8 pr-6 w-full md:w-2/3"
            label="Name" />
          <select-input
            v-model="form.type"
            :error="form.errors.type"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Type">
            <option value="STOCK">
              STOCK
            </option>
            <option value="SERVICE">
              SERVICE
            </option>
          </select-input>
          <template v-if="form.type === 'STOCK'">
            <select-input
              v-model="form.item_inv_type_main_id"
              :error="form.errors.item_inv_type_main_id"
              class="pb-8 pr-6 w-full md:w-1/2"
              label="Kategori Utama">
              <option :value="null" disabled>
                Pilih kategori...
              </option>
              <option
                v-for="main in itemInvMains"
                :key="main.id"
                :value="main.id">
                {{ main.name }}
              </option>
            </select-input>
            <select-input
              v-model="form.item_inv_type_sub_id"
              :error="form.errors.item_inv_type_sub_id"
              class="pb-8 pr-6 w-full md:w-1/2"
              label="Sub Kategori">
              <option :value="null" :disabled="availableSubs.length > 0">
                N/A
              </option>
              <option
                v-for="sub in availableSubs"
                :key="sub.id"
                :value="sub.id">
                {{ sub.name }}
              </option>
            </select-input>
          </template>
          <div class="w-full" />
          <select-input
            v-model="form.ref_unit_id"
            :error="form.errors.ref_unit_id"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Default Unit (Small)">
            <option
              :value="null"
              selected
              disabled />
            <option
              v-for="unit in units"
              :key="unit.id"
              :value="unit.id">
              {{ unit.name }}
            </option>
          </select-input>
          <select-input
            v-model="form.ref_unit_id_2"
            :error="form.errors.ref_unit_id_2"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Large Unit">
            <option
              :value="null"
              selected
              disabled />
            <option
              v-for="unit in units"
              :key="unit.id"
              :value="unit.id">
              {{ unit.name }}
            </option>
          </select-input>
          <number-input
            v-model="form.convert_value"
            :error="form.errors.convert_value"
            class="pb-8 pr-6 w-full md:w-1/3"
            input-class="text-right"
            label="Convert Value" />
          <textarea-input
            v-model="form.desc"
            :error="form.errors.desc"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Description" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create Item
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import NumberInput from '@/Shared/NumberInput'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        NumberInput,
    },
    layout: Layout,
    remember: 'form',
    props: {
        units: Array,
        itemInvMains: Array,
        itemInvSubs: Array,
    },
    data () {
        return {
            form: this.$inertia.form({
                name: null,
                type: 'STOCK',
                item_inv_type_main_id: null,
                item_inv_type_sub_id: null,
                ref_unit_id: null,
                ref_unit_id_2: null,
                convert_value: 1,
                desc: null,
            }),
        }
    },
    computed: {
        availableSubs () {
            if (!this.form.item_inv_type_main_id) return []
            return this.itemInvSubs.filter(s => s.parent_id === this.form.item_inv_type_main_id)
        },
    },
    watch: {
        'form.type' (type) {
            if (type === 'SERVICE') {
                this.form.item_inv_type_main_id = null
                this.form.item_inv_type_sub_id = null
            }
        },
        'form.item_inv_type_main_id' () {
            if (this.form.item_inv_type_sub_id && !this.availableSubs.some(s => s.id === this.form.item_inv_type_sub_id)) {
                this.form.item_inv_type_sub_id = null
            }
        },
    },
    methods: {
        store () {
            this.form.post('/items')
        },
    },
}
</script>
